export const DOCUMENT_REGISTER_PATH = "/document-register/:registerId";
